export const formatCpfCnpj = (value = "") => {
    const raw = `${value || ""}`.trim()
    const digits = raw.replace(/\D/g, "")

    // CPF (até 11)
    if (digits.length <= 11) {
        return digits
            .replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (_, a, b, c, d) =>
                [a, b, c].filter(Boolean).join(".") + (d ? `-${d}` : "")
            )
    }

    // CNPJ (14)
    if (digits.length === 14) {
        return digits.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            (_, a, b, c, d, e) => `${a}.${b}.${c}/${d}-${e}`
        )
    }

    return raw
}